<div class="row ng-scope">
  <div class="col-12">

    <div class="row form-group">
      <label class="control-label col-2 ng-binding">Quyển số</label>
      <div class="col-4">
        <input type="text" tabIndex="1" class="form-control" placeholder="" [(ngModel)]="doituongSelect.QuyenSo">
      </div>
      <label class="control-label col-2 ng-binding">Số phiếu<span class="required">(*)</span></label>
      <div class="col-4">
        <input type="number" tabIndex="2" class="form-control" placeholder="" [(ngModel)]="doituongSelect.SoPhieu">
      </div>
    </div>

    <div class="row form-group">
      <label class="control-label col-2 ng-binding">Ngày nộp<span class="required">(*)</span></label>
      <div class="col-4">
        <kendo-dateinput style="width:100%;float:left" tabIndex="3" [format]="'dd/MM/yyyy'" [(value)]="doituongSelect.Ngay"></kendo-dateinput>
      </div>
      <label class="control-label col-2 ng-binding">Số tiền<span class="required">(*)</span></label>
      <div class="col-4">
        <input class="form-control"
               maxlength="20"
               tabindex="4"
               currencyMask
               [(ngModel)]="doituongSelect.SoTien"
               name="value"
               [placeholder]="''"
               [options]="ngxCurrencyOptions" autocomplete="off" />
      </div>
    </div>

    <div class="row form-group">
      <label class="control-label col-2 ng-binding">Ngày tính học phí<span class="required">(*)</span></label>
      <div class="col-4">
        <kendo-dateinput style="width:100%;float:left" tabIndex="5" [format]="'dd/MM/yyyy'" [(value)]="doituongSelect.NgayChungTu"></kendo-dateinput>
      </div>

      <label class="control-label col-2 ng-binding">Người tạo</label>
      <div class="col-4">
        <input type="text" tabIndex="6" class="form-control" placeholder="" disabled="disabled" [(ngModel)]="doituongSelect.CreatedBy">
      </div>
    </div>


    <div class="row form-group">
      <label class="control-label col-2 ng-binding">Hình thức<span class="required">(*)</span></label>
      <div class="col-4">
        <ng-select #slHinhThuc
                   class="twcollong"
                   [tabIndex]="7"
                   [openOnEnter]="false"
                   [items]="inputhinhthucs"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn2"
                   [(ngModel)]="doituongSelect.HinhThuc">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
      <label class="control-label col-2 ng-binding">P thức<span class="required">(*)</span></label>
      <div class="col-4">
        <ng-select #slPhuongThuc
                   class="twcollong"
                   [tabIndex]="8"
                   [openOnEnter]="false"
                   [items]="inputphuongthucs"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn2"
                   [(ngModel)]="doituongSelect.PhuongThuc">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>




    <div class="row form-group">
      <label class="control-label col-2 ng-binding">Ghi chú</label>
      <div class="col-10">
        <textarea type="text" tabIndex="9" rows="4" class="form-control" placeholder="" [(ngModel)]="doituongSelect.GhiChu"></textarea>
      </div>
    </div>






  </div>

</div>
<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div style="display:flex;">
    <!--<div class="checkbox c-checkbox">
      <label>
        <input tabIndex="20" type="checkbox" [(ngModel)]="doituongSelect.TrangThai" />
        <span class="fa fa-check"></span> Hoạt động
      </label>
    </div>-->
  </div>
  <div class="">
    <button *ngIf="!(quyen_sua==false && doituongSelect.Id!=null)"
            type="submit"
            (click)="saveproduct()"
            title="Ấn F9 để lưu"
            class="mb-1 mr-1 btn btn-primary"
            [disabled]="isSubmitting">
      Lưu lại
    </button>
    <button type="submit" style="margin-left:2px;" (click)="export('pdf')" class="mb-1 mr-1 btn btn-info btn-bloc">In phiếu thu</button>
    <button type="submit" style="margin-left:2px;" (click)="export('xlsx')" class="mb-1 mr-1 btn btn-success">Xuất excel</button>
    <button type="submit" style="margin-left:2px;" (click)="export2('pdf')" class="mb-1 mr-1 btn btn-info btn-bloc">In phiếu thu 2 liên</button>
    <button type="submit" style="margin-left:2px;" (click)="export2('xlsx')" class="mb-1 mr-1 btn btn-success">Xuất excel 2 liên</button>
    <!--<button class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="Ấn ESC để thoát" style="padding-top:0px !important">Hủy bỏ</button>-->
  </div>

</div>




